









import Vue from 'vue';
import { AppptBannerInstructions, ApptScheduleSteps } from '@/constants';
import { ApptBannerData } from '@/types';
import RightTickCircleIcon from '@/assets/icons/RightTickCircle.vue';

export default Vue.extend({
  name: 'Banner',
  components: {
    RightTickCircleIcon
  },
  props: {
    currentStep: {
      type: String,
      required: true
    },
    isModifyMode: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    bannerData (): ApptBannerData {
      const currentStep = this.isModifyMode && this.currentStep === ApptScheduleSteps.APPOINTMENT_SCHEDULED ? ApptScheduleSteps.APPOINTMENT_RESCHEDULED : this.currentStep;
      return AppptBannerInstructions.find((instr) => instr.name === currentStep) || {} as ApptBannerData;
    }
  }
})
